import { FC } from "react";
import GText from "./GText";
import { css } from "@emotion/react";
import { BaseProps } from "./text";

interface Prop {
  text?: string;
  duration?: number;
}

const GTextGlitch: FC<Prop & BaseProps> = (props) => {
  const glitchStyles = css`
    display: grid;
    grid-template-columns: 1fr;
    font-family: inherit;

    & span {
      --stack-height: calc(100% / var(--stacks) - 1px);
      --inverse-index: calc(calc(var(--stacks) - 1) - var(--index));
      --clip-top: calc(var(--stack-height) * var(--index));
      --clip-bottom: calc(var(--stack-height) * var(--inverse-index));

      font-weight: bold;
      grid-row-start: 1;
      grid-column-start: 1;
      font-size: inherit;
      clip-path: inset(var(--clip-top) 0 var(--clip-bottom) 0);
      animation: stack 340ms cubic-bezier(0.46, 0.29, 0, 1.24) 1 backwards
          calc(var(--index) * 120ms),
        glitch 2s ease infinite 2s alternate-reverse;
      font-family: inherit;
    }

    & span:nth-child(odd) {
      --glitch-translate: 8px;
    }
    & span:nth-child(even) {
      --glitch-translate: -8px;
    }

    @keyframes stack {
      0% {
        opacity: 0;
        transform: translateX(-50%);
        text-shadow: -2px 3px 0 red, 2px -3px 0 blue;
      }
      60% {
        opacity: 0.5;
        transform: translateX(50%);
      }
      80% {
        transform: none;
        opacity: 1;
        text-shadow: 2px -3px 0 red, -2px 3px 0 blue;
      }
      100% {
        text-shadow: none;
      }
    }

    @keyframes glitch {
      0% {
        text-shadow: -2px 3px 0 red, 2px -3px 0 blue;
        transform: translate(var(--glitch-translate));
      }
      2% {
        text-shadow: 2px -3px 0 red, -2px 3px 0 blue;
      }
      4%,
      100% {
        text-shadow: none;
        transform: none;
      }
    }
  `;

  return (
    <GText {...props}>
      {/* @ts-ignore */}
      <div css={glitchStyles} style={{ "--stacks": 3 }}>
        {Array(3)
          .fill("")
          .map((_, i) => (
            // @ts-ignore
            <span key={i} style={{ "--index": i }}>
              {props.text}
            </span>
          ))}
      </div>
    </GText>
  );
};

GTextGlitch.defaultProps = {
  text: "Grooody",
  fontSize: 50,
  color: "#fff",
};

/*
addPropertyControls(TextGlitch, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
})
*/

export default GTextGlitch;
